/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archival_HintInputs */



/**
* | output |
* | --- |
* | "No games recorded for this event. Enter the winner and the number of players from the archive." |
*
* @param {Archival_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const archival_hint = /** @type {((inputs?: Archival_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archival_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune partie enregistrée pour ce tournoi. Saisissez le vainqueur et le nombre de joueurs d'après les archives.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay partidas registradas para este torneo. Indique el ganador y el número de jugadores según el archivo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhuma partida registrada para este torneio. Informe o vencedor e o número de jogadores a partir do arquivo.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna partita registrata per questo torneo. Inserisci il vincitore e il numero di giocatori dall'archivio.")
	return /** @type {LocalizedString} */ ("No games recorded for this event. Enter the winner and the number of players from the archive.")
});